import { jwtDecode } from "jwt-decode";

export const AUTH_TOKEN_UPDATED_EVENT = "auth-token-updated";
export const AUTH_SESSION_EXPIRED_EVENT = "auth-session-expired";

export const loadAuthTokenFromLocalStorage = () => {
  return window.localStorage.getItem("auth_token");
};

export const saveAuthTokenInLocalStorage = (authToken) => {
  // Don't use this method. Update the authToken state in HomePage.js through the authContext instead.
  window.localStorage.setItem("auth_token", authToken);
  window.dispatchEvent(new CustomEvent(AUTH_TOKEN_UPDATED_EVENT, { detail: authToken }));
};

export const clearAuthToken = () => {
  window.localStorage.removeItem("auth_token");
  window.dispatchEvent(new Event(AUTH_SESSION_EXPIRED_EVENT));
};

export const decodeAuthToken = (authToken = loadAuthTokenFromLocalStorage()) => {
  return authToken ? jwtDecode(authToken) : null;
};

export const getCompanyIdFromAuthToken = () => {
  return decodeAuthToken()?.companyId?.id ?? null;
};

export const getUserIdFromAuthToken = () => {
  return decodeAuthToken()?.userId ?? null;
};

export const getRoleFromAuthToken = () => {
  return decodeAuthToken()?.role ?? null;
};

export const getRealestatesFromAuthToken = (authToken) => {
  return decodeAuthToken(authToken)?.realestateIds ?? [];
};

export const getAuthTokenExpiration = () => {
  return decodeAuthToken()?.exp ?? null;
};

export const hasCompletedStarterChallenges = () => {
  return decodeAuthToken()?.starterChallengesCompleted === true;
};
